(() => {
  let controller;
  let cleanup = [];
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    if (controller) controller.abort();
    cleanup.forEach(fn => fn()); cleanup = [];
    controller = new AbortController();
    const on = (el, event, fn, options = {}) => el && el.addEventListener(event, fn, {...options, signal:controller.signal});
    const observe = (el, fn) => { if (!el) return; const observer = new ResizeObserver(fn); observer.observe(el); cleanup.push(() => observer.disconnect()); };
    document.querySelectorAll('.offer-strip,.announcement').forEach(bar => {
      const pause = bar.querySelector('button');
      const isOffer = bar.classList.contains('offer-strip');
      const label = isOffer ? 'offer banner' : 'announcement rotation';
      on(pause, 'click', () => {
        const paused = bar.classList.toggle('is-paused');
        pause.setAttribute('aria-pressed', String(paused));
        pause.setAttribute('aria-label', (paused ? 'Resume ' : 'Pause ') + label);
        pause.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      });
      if (isOffer) {
        const group = bar.querySelector('.offer-group');
        const speed = () => bar.style.setProperty('--offer-duration', group.getBoundingClientRect().width / 45 + 's');
        observe(group, speed); speed();
      }
    });
    const shop = document.getElementById('shop');
    if (shop) {
      const options = [...shop.querySelectorAll('.color-option')];
      options.forEach(option => on(option, 'click', () => {
        options.forEach(button => button.setAttribute('aria-pressed', String(button === option)));
        shop.querySelector('#selected-color').textContent = option.dataset.color;
        const image = shop.querySelector('#purchase-photo');
        image.src = option.dataset.image; image.alt = option.dataset.alt;
        shop.querySelector('#purchase-price').textContent = option.dataset.price;
        shop.querySelector('#purchase-link').href = option.dataset.url;
        shop.querySelector('#shipping-note').textContent = option.dataset.available === 'true' ? shop.dataset.stockMessage : shop.dataset.unavailableMessage;
      }));
    }
    document.querySelectorAll('a[href^="#"]').forEach(link => on(link, 'click', event => {
      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
      target.scrollIntoView({behavior:reduced() ? 'auto' : 'smooth',block:'start'});
    }));
    const track = document.getElementById('review-track');
    if (track) {
      const cards = [...track.querySelectorAll('.review-card')];
      const previous = document.querySelector('.review-prev');
      const next = document.querySelector('.review-next');
      const status = document.querySelector('.review-position');
      const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        status.textContent = cards.length ? 'Review ' + Math.min(cards.length, Math.round(track.scrollLeft / step()) + 1) + ' of ' + cards.length : 'No reviews';
      };
      const move = direction => track.scrollBy({left:direction * step(),behavior:reduced() ? 'auto' : 'smooth'});
      on(previous,'click',() => move(-1)); on(next,'click',() => move(1));
      on(track,'keydown',event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {event.preventDefault();move(event.key === 'ArrowRight' ? 1 : -1);}
      });
      on(track,'scroll',update,{passive:true}); observe(track,update); update();
    }
    document.querySelectorAll('.nlp-video').forEach(video => {
      if (reduced()) {video.autoplay = false; video.pause();}
    });
  }
  init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',() => requestAnimationFrame(init));
  document.addEventListener('shopify:block:select',event => {
    if (event.target.classList.contains('color-option')) event.target.click();
    const card = event.target.closest('.review-card');
    if (card) card.scrollIntoView({behavior:'auto',block:'nearest',inline:'start'});
  });
})();
